module.exports = __webpack_public_path__ + "img/ridee-logo.f4d1096a.png";